document.addEventListener("DOMContentLoaded", function () {
  var selectors = [
    ".section-fivepetal-text-with-media .fivepetal-readmore-link",
    ".section-fivepetal-image-with-text .fivepetal-readmore-link",
  ];
  document.querySelectorAll(selectors.join(",")).forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var controls = link.getAttribute("aria-controls");
      var target = document.getElementById(controls);
      if (!target) return;
      var expanded = link.getAttribute("aria-expanded") === "true";
      link.setAttribute("aria-expanded", String(!expanded));
      target.setAttribute("aria-hidden", expanded ? "true" : "false");
      var alt = link.getAttribute("data-alt-label");
      var def = link.getAttribute("data-default-label");
      if (alt && def) {
        link.textContent = expanded ? def : alt;
      }
    });
  });
});
